import { Skeleton, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Market, Outcome, StyleObj } from '../../../@types';
import OutcomeTableCell from '../../atoms/OutcomeTableCell';
import { getColumnStyle } from '../../../utils';

type MarketTableDisplaySingleProps = {
  data: Market;
  handleCellClick: (market: Market, outcome: Outcome) => void;
};

const styles: StyleObj = {
  tableContainer: (theme) => ({
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.neutral[600]}`,
    boxShadow: 'none',
  }),
  tableHead: {
    backgroundColor: 'neutral.600',
    borderBottom: 'none',
    '& .MuiTableCell-root': {
      p: 1,
    },
  },
  tableRow: {
    borderTop: '1px solid',
    borderColor: 'neutral.600',
  },
  tableHeadCell: {
    borderBottom: 'none',
    p: 0,
  },
  outcomeCell: (theme) => ({
    color: 'secondary.main',
    backgroundColor: theme.palette.neutral[800],
    cursor: 'pointer',
    border: `1px solid ${theme.palette.neutral[600]}`,
    borderBottomColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.neutral[600],
    },
  }),
  mainMarketOutcomeType: {
    typography: {
      xs: 'body3',
      md: 'body2',
    },
    color: 'neutral.200',
  },
};

const MarketTableDisplaySingle = ({ data, handleCellClick }: MarketTableDisplaySingleProps) => {
  const columnDisplay = getColumnStyle(data.outcomes);
  return (
    <TableContainer component={Paper} sx={styles.tableContainer}>
      <MuiTable aria-label='events table'>
        {!data && <Skeleton variant='rectangular' width='100%' height={40} animation='wave' />}
        <TableHead sx={styles.tableHead}>
          <TableRow sx={styles.tableRow}>
            {data.marketType.outcomeTypes.map((outcomeTypes) => {
              const outcome = data.outcomes.find((o) => o.outcomeTypeId === outcomeTypes.id);
              return (
                <TableCell align='center' key={outcome?.id} sx={styles.tableHeadCell}>
                  <Typography sx={styles.mainMarketOutcomeType} component='span' key={outcome?.id}>
                    {outcome?.shortName || outcome?.name}
                  </Typography>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={styles.tableRow}>
            {data.marketType.outcomeTypes.map((outcomeType) => {
              const outcome = data.outcomes.find((o) => o.outcomeTypeId === outcomeType.id);
              return (
                <OutcomeTableCell
                  key={outcomeType?.id}
                  outcome={outcome}
                  sportId={data.marketType?.sportId}
                  specialValues={data.specialValues}
                  onClick={() => {
                    if (outcome) {
                      handleCellClick(data, outcome);
                    }
                  }}
                  disabled={!data.isActive || !outcome?.isActive}
                  isMarketSingleDisplayType
                  marketTypeName={data.marketType?.name}
                  columnStyle={columnDisplay}
                />
              );
            })}
          </TableRow>
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default MarketTableDisplaySingle;
